module.exports = __webpack_public_path__ + "img/a4tech.e322aae.png";